import { watch } from "vue";
import VueGtag, { trackRouter } from "vue-gtag-next";

export default defineNuxtPlugin((nuxtApp) => {
  const env = useRuntimeConfig();
  const ANALYTICS_APP_KEY = env["public"]["ANALYTICS_APP_KEY"];
  if (!ANALYTICS_APP_KEY) return;

  const { consentGiven } = useCookieConsent();

  const enableAnalytics = () => {
    nuxtApp.vueApp.use(VueGtag, {
      property: {
        id: ANALYTICS_APP_KEY,
      },
    });
    trackRouter(useRouter());
  };

  // Google Analytics imposta cookie di tracciamento: carichiamolo solo dopo
  // il consenso esplicito (banner CookieConsentBanner.vue), non al boot.
  if (consentGiven.value) {
    enableAnalytics();
  } else {
    const stop = watch(consentGiven, (accepted) => {
      if (accepted) {
        enableAnalytics();
        stop();
      }
    });
  }
});
